import { Component, OnInit, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { SubmitCancelComponent } from "@Common/events";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { KeyStoreService } from "../key-store.service";
import { ConfigService } from "../config.service";
import { FormDataService } from '../form-data.service';
import { ExtensionService, SshAgentExtensionService } from '@Common/util';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
standalone: false,
  selector: 'fx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent extends SubmitCancelComponent implements OnInit {
  form = new FormGroup({} as any);
  sub$;
  config:any = {};
  usePK = false;
  manage = false;
  @Input () error;
  @Input () disable = false;
  @Input() set adminLogin(l) {
    this.form.patchValue({ admin: l });
  }
  @Input() username = '';
  _inputType = "password";
  inputType() {
    return this._inputType;
  }
  toggleInputType() {
    if(this._inputType === 'password')
      this._inputType = "text";
    else 
      this._inputType = 'password';
  }
  constructor(private fb: FormBuilder, 
    private ks: KeyStoreService, 
    private cs: ConfigService,
    private cdr: ChangeDetectorRef,
    private fds: FormDataService,
    private  sshAgent: SshAgentExtensionService,
    private domSanitizer: DomSanitizer) { 

    super ();
  }
  @ViewChild ("username", {static: false}) un;
  
  ngOnInit() {
    this.disable = false;
    this.fds.reset();
    this.form = this.fds.form;
    this.sub$ = this.cs.config ().subscribe ((d:any) => {
      this.config = d;
      this.form.patchValue ({
        username: this.username,
        usePK: false ,
        admin: d.disable,
        banner: d.banner
      });
      
      this.cdr.detectChanges ();
    });
  }
  ngAfterViewInit () {
    setTimeout (() => { this.un.nativeElement.focus (); });
  }
  ngOnChange(change) {
    this.form.patchValue({
      username: change.currentValue
    });
  }
  ngOnDestroy () {
    this.sub$.unsubscribe ();
  }
  async onSubmit () {
    // use the agent, or the localhost keys, not both
    this.form.patchValue({ usePK: Boolean( 
        this.sshAgent.enabled() ? 
            this.sshAgent.agentConnected() : 
            await this.ks.usePK() 
        ) 
    });
    
    this.disable = true;
    this.fds.patchValue(this.form.value);
    this.submit.emit (this.fds.value);
  }
  sshDisable() {
    return this.config.disable;
  }
  showPassword () {
    if(this.form.value['admin'])
      return true;
    return (this.config.showPassword);
  }
  showPublicKey () {
    return !this.sshAgent.enabled() && (!this.sshAgent.agentConnected()) && !this.config.hideManagePrivateKeys;

    // if(this.form.value['admin'])
    //   return true;
    // return   this.config.showPK;
  }
  extEnabled() {
    return this.sshAgent.enabled();
  }
  extConnected() {
    return this.sshAgent.agentConnected();
  }
  extError() {
    return this.sshAgent.failedError;
  }
  showServers () {
    return this.config.servers && this.config.servers.length;
  }
  admin (bool) {
    this.fds.reset();
    this.form.patchValue({ admin: bool });
  }
  localLogin () {
    return this.form.value['admin'];
  }
  showManage () {
    return this.manage;
  }
  manageKeys () {
    this.manage = true;
  }
  async onManageDone () {
    await this.ks.reset ();
    this.manage = false;
  }
  showTerms() {

  }
  hasAuthMethods() {
    
  }
  sanitize(html) {
    return this.domSanitizer.bypassSecurityTrustHtml(html);
  }
  installClientText() {
    return "Install the FastX Client version 4.1.20 or later to use your SSH agent.";
  }
  showInstall() {
    return ['notready'].indexOf(this.sshAgent?.failedError?.name) < 0;
  }

}
